/* unplugin-vue-components disabled */import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "ele-wrapper-bgCard"
};
const _hoisted_3 = {
  class: "app-container"
};
const _hoisted_4 = {
  style: {
    "height": "9vh",
    "width": "100%",
    "display": "flex",
    "flex-wrap": "wrap",
    "justify-content": "space-around",
    "margin-bottom": "2vh"
  }
};
const _hoisted_5 = {
  class: "box-item"
};
const _hoisted_6 = {
  class: "item-num"
};
const _hoisted_7 = {
  class: "box-item"
};
const _hoisted_8 = {
  class: "item-num"
};
const _hoisted_9 = {
  class: "box-item"
};
const _hoisted_10 = {
  class: "item-num"
};
const _hoisted_11 = {
  class: "box-item"
};
const _hoisted_12 = {
  class: "item-num"
};
import * as echarts from 'echarts';
import DatePicker from "@/components/DatePicker";
import { getSumStatistics, getTaskNumStatistics, getTaskFlightTimeStatistics, getTaskFlightDistanceStatistics, getStatisticsByDeviceType, getAlarmStatistics, getFlowStatistics, listDrone } from "@/api/base/statistic";
import { treeselect } from "@/api/system/dept";
import { getDefaultDate } from '@/utils/date';
export default {
  __name: 'index',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const dateRange = ref([]); // 日期范围
    const droneList = ref([]);
    const totalFlightTimeInYear = ref(0);
    const totalFlightTimeInMonth = ref(0);
    const totalFlightDistanceInYear = ref(0);
    const totalFlightDistanceInMonth = ref(0);
    const deptOptions = ref(undefined);
    const queryParams = ref({
      deviceId: undefined,
      deptId: undefined,
      groupByType: "day"
    });
    function setDateRange(val) {
      dateRange.value = val;
    }
    function setGroupByType(val) {
      queryParams.value.groupByType = val;
    }
    onMounted(() => {
      treeselect().then(response => {
        deptOptions.value = response.data;
      });
      listDrone().then(response => {
        droneList.value = response.data;
      });
      dateRange.value = getDefaultDate();
      nextTick(() => {
        initeCharts();
      });
    });
    function handleQuery() {
      nextTick(() => {
        getList();
      });
    }

    /** 重置按钮操作 */
    function resetQuery() {
      dateRange.value = [];
      proxy.$refs["datePickerRef"].reset();
      proxy.resetForm('queryRef');
      queryParams.value.groupByType = "day";
      dateRange.value = getDefaultDate();
      handleQuery();
    }
    function getList() {
      console.log(dateRange.value);
      //TODO 飞行时长与飞行公里数的年度月度统计
      getSumStatistics(queryParams.value).then(response => {
        totalFlightTimeInYear.value = (response.data.totalFlightTimeInYear / 60).toFixed(2);
        totalFlightTimeInMonth.value = (response.data.totalFlightTimeInMonth / 60).toFixed(2);
        totalFlightDistanceInYear.value = response.data.totalFlightDistanceInYear / 1000;
        totalFlightDistanceInMonth.value = response.data.totalFlightDistanceInMonth / 1000;
      });
      //TODO 载体任务飞行次数统计
      getTaskNumStatistics(proxy.addDateRange(queryParams.value, dateRange.value, "statistic")).then(response => {
        state.option.xAxis.data = response.data.xData;
        if (response.data.StatisticsList.length > 0) {
          state.option.series[0].data = [];
          response.data.StatisticsList.map(item => {
            state.option.series[0].data.push(item.nums);
          });
          myChart.clear();
          myChart.resize();
          myChart.setOption(state.option, true);
        } else {
          state.option.series[0].data = [];
          myChart.clear();
          myChart.resize();
          myChart.setOption(state.option, true);
        }
      });
      //TODO 载体任务飞行时长统计
      getTaskFlightTimeStatistics(proxy.addDateRange(queryParams.value, dateRange.value, "statistic")).then(response => {
        state.option1.xAxis.data = response.data.xData;
        if (response.data.StatisticsList.length > 0) {
          state.option1.series[0].data = [];
          response.data.StatisticsList.map(item => {
            state.option1.series[0].data.push(item.nums / 1000);
          });
          myChart1.clear();
          myChart1.resize();
          myChart1.setOption(state.option1, true);
        } else {
          state.option1.series[0].data = [];
          myChart1.clear();
          myChart1.resize();
          myChart1.setOption(state.option1, true);
        }
      });
      //TODO 载体任务飞行距离统计
      getTaskFlightDistanceStatistics(proxy.addDateRange(queryParams.value, dateRange.value, "statistic")).then(response => {
        state.option2.xAxis.data = response.data.xData;
        if (response.data.StatisticsList.length > 0) {
          state.option2.series[0].data = [];
          state.option2.series[1].data = [];
          response.data.StatisticsList.map(item => {
            state.option2.series[0].data.push(item.nums / 1000);
            state.option2.series[1].data.push(item.nums / 1000);
          });
          myChart2.clear();
          myChart2.resize();
          myChart2.setOption(state.option2, true);
        } else {
          state.option2.series[0].data = [];
          myChart2.clear();
          myChart2.resize();
          myChart2.setOption(state.option2, true);
        }
      });
      //TODO 设备统计
      getStatisticsByDeviceType().then(response => {
        let legendData = [];
        response.data.legendData.map(item => {
          legendData.push(item.dictLabel);
        });
        state.option3.legend.data = legendData;
        let seriesData = [];
        let seriesData1 = [];
        response.data.StatisticsList.map(item => {
          if (item.deviceType === "固定翼无人机" || item.deviceType === "多旋翼无人机" || item.deviceType === "固定翼有人机" || item.deviceType === "直升机") {
            seriesData.push({
              value: item.nums,
              name: item.deviceType
            });
          } else {
            seriesData1.push({
              value: item.nums,
              name: item.deviceType
            });
          }
        });
        state.option3.series[0].data = seriesData;
        state.option3.series[1].data = seriesData1;
        myChart3.clear();
        myChart3.resize();
        myChart3.setOption(state.option3, true);
      });
      //TODO 告警统计
      getAlarmStatistics(proxy.addDateRange(queryParams.value, dateRange.value, "statistic")).then(response => {
        let legendData = [];
        response.data.legendData.map(item => {
          legendData.push(item.reportName);
        });
        state.option4.legend.data = legendData;
        state.option4.xAxis.data = response.data.xData;
        if (response.data.StatisticsList.length > 0) {
          state.option4.series = [];
          let series = [];
          response.data.StatisticsList.map((item, index) => {
            series.push({
              name: item.label,
              smooth: true,
              type: item.label === "火焰" || item.label === "烟雾" ? 'line' : 'bar',
              data: item.statisticDatas.map(tmp => {
                return tmp.nums;
              })
            });
          });
          state.option4.series = series;
          myChart4.clear();
          myChart4.resize();
          myChart4.setOption(state.option4, true);
        } else {
          state.option4.series = state.option4.series.map(item => {
            item.data = [];
            return item;
          });
          myChart4.clear();
          myChart4.resize();
          myChart4.setOption(state.option4, true);
        }
      });
      //TODO 载荷流量及时长统计
      getFlowStatistics(proxy.addDateRange(queryParams.value, dateRange.value, "statistic")).then(response => {
        state.option5.xAxis.data = response.data.xData;
        if (response.data.StatisticsList.length > 0) {
          state.option5.series[0].data = [];
          state.option5.series[1].data = [];
          response.data.StatisticsList.map(item => {
            state.option5.series[0].data.push(item.totalFlow);
            state.option5.series[1].data.push(item.totalTime);
          });
          myChart5.clear();
          myChart5.resize();
          myChart5.setOption(state.option5, true);
        } else {
          state.option5.series[0].data = [];
          state.option5.series[1].data = [];
          myChart5.clear();
          myChart5.resize();
          myChart5.setOption(state.option5, true);
        }
      });
    }
    let myChart, myChart1, myChart2, myChart3, myChart4, myChart5;
    const initeCharts = () => {
      myChart = echarts.init(document.getElementById('myChart'));
      myChart.setOption(state.option);
      myChart1 = echarts.init(document.getElementById('myChart1'));
      myChart1.setOption(state.option1);
      myChart2 = echarts.init(document.getElementById('myChart2'));
      myChart2.setOption(state.option2);
      myChart3 = echarts.init(document.getElementById('myChart3'));
      myChart3.setOption(state.option3);
      myChart4 = echarts.init(document.getElementById('myChart4'));
      myChart4.setOption(state.option4);
      myChart5 = echarts.init(document.getElementById('myChart5'));
      myChart5.setOption(state.option5);
      getList();
    };
    const state = reactive({
      option: {
        title: {
          text: "任务次数(次)",
          top: 10,
          textStyle: {
            color: "#5c6076"
          }
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}: {c}次",
          extraCssText: "box-shadow: 0 0 0.5rem rgba(0, 0, 0, 1)"
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          max: function (value) {
            return value.max;
          }
        },
        textStyle: {
          color: "#008eff"
        },
        series: [{
          name: "任务次数",
          type: "bar",
          barWidth: "15%",
          itemStyle: {
            normal: {
              color: "#008eff",
              barBorderRadius: 12
            }
          },
          label: {
            normal: {
              show: true,
              position: "top",
              textStyle: {
                color: "#008eff",
                fontSize: 8
              }
            }
          },
          data: [120, 200, 150, 80, 70, 110, 130, 160, 70, 140, 190, 60]
        }]
      },
      option1: {
        title: {
          text: "飞行时长(h)",
          top: 10,
          textStyle: {
            color: "#5c6076"
          }
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b}: {c}h",
          extraCssText: "box-shadow: 0 0 0.5rem rgba(0, 0, 0, 1)",
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: "rgba(0, 255, 233,0)"
                }, {
                  offset: 0.5,
                  color: "rgba(255, 255, 255,1)"
                }, {
                  offset: 1,
                  color: "rgba(0, 255, 233,0)"
                }],
                global: false
              }
            }
          }
        },
        xAxis: {
          type: "category",
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          name: "",
          splitNumber: 2,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#B8C6D9"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#C9DFB5"
            }
          },
          // y轴文字
          axisLabel: {
            show: true,
            textStyle: {
              color: "#0988ef"
            }
          }
        },
        series: [{
          name: "",
          barMinHeight: 10,
          type: "pictorialBar",
          barCategoryGap: "60%",
          // symbol: 'path://M0,10 L10,10 L5,0 L0,10 z',
          symbol: "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
          itemStyle: {
            normal: {
              //barBorderRadius: 5,
              //渐变色
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#1b3994"
              }, {
                offset: 0.5,
                color: "#266cc2"
              }, {
                offset: 1,
                color: "#2259b1"
              }])
            }
          },
          label: {
            normal: {
              show: true,
              position: "top",
              textStyle: {
                color: "#11f559",
                fontSize: 8
              }
            }
          },
          data: [334, 584, 164, 259, 158, 269, 179, 268, 103, 369, 356, 712],
          z: 10
        }]
      },
      option2: {
        title: {
          text: "公里数(km)",
          top: 10,
          textStyle: {
            color: "#5c6076"
          }
        },
        tooltip: {
          show: true,
          formatter: "{b}: {c}km",
          extraCssText: "box-shadow: 0 0 0.5rem rgba(0, 0, 0, 1)"
        },
        xAxis: {
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
          axisLine: {
            show: false
          },
          type: "category",
          axisTick: {
            show: false
          }
        },
        yAxis: {
          ayisLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#5c6076"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#2e3547"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#384157"
            }
          }
        },
        series: [{
          type: "bar",
          name: "linedemo",
          tooltip: {
            show: false
          },
          animation: false,
          barWidth: 1.4,
          hoverAnimation: false,
          data: [2220, 1682, 2791, 3000, 3090, 3230, 2910, 1068, 4096, 2048, 1236, 2200],
          itemStyle: {
            normal: {
              color: "#f17a52",
              opacity: 0.6,
              label: {
                show: false
              }
            }
          }
        }, {
          type: "line",
          name: "linedemo",
          smooth: true,
          symbolSize: 10,
          animation: false,
          lineWidth: 1.2,
          hoverAnimation: false,
          data: [2220, 1682, 2791, 3000, 3090, 3230, 2910, 1068, 4096, 2048, 1236, 2200],
          symbol: "circle",
          itemStyle: {
            normal: {
              color: "#f17a52",
              shadowBlur: 40,
              label: {
                show: true,
                position: "top",
                textStyle: {
                  color: "#f17a52",
                  fontSize: 8
                }
              }
            }
          },
          areaStyle: {
            normal: {
              color: "#f17a52",
              opacity: 0.08
            }
          }
        }]
      },
      option3: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          top: 10,
          left: 20,
          itemGap: 15,
          orient: 'vertical',
          textStyle: {
            color: "#a9acb3"
          },
          data: ['固定翼无人机', '多旋翼无人机', '固定翼有人机', '直升机', '任务车', '吊舱', 'VSAT天线', '4G基站', '铱星', '灭火包', '倾斜相机', '用户中心', '时空服务中心', '监测智慧杆', '陆地机动站'],
          formatter: function (name) {
            var data = state.option3.series[0].data;
            var data1 = state.option3.series[1].data;
            var tarValue = 0;
            for (var i = 0, l = data.length; i < l; i++) {
              if (data[i].name === name) {
                tarValue = data[i].value;
              }
            }
            for (var i = 0, l = data1.length; i < l; i++) {
              if (data1[i].name === name) {
                tarValue = data1[i].value;
              }
            }
            return name + "  " + tarValue;
          }
        },
        series: [{
          name: '载体',
          type: 'pie',
          center: ['65%', '50%'],
          radius: [0, '50%'],
          clockwise: false,
          animation: false,
          label: {
            position: 'inner',
            fontSize: 12,
            fontWeight: 'bold',
            rotate: true,
            formatter: '{d}%'
          },
          labelLine: {
            show: false
          },
          data: [{
            value: 3,
            name: '固定翼无人机'
          }, {
            value: 6,
            name: '多旋翼无人机'
          }, {
            value: 2,
            name: '固定翼有人机'
          }, {
            value: 8,
            name: '直升机'
          }]
        }, {
          name: '载荷',
          type: 'pie',
          center: ['65%', '50%'],
          radius: ['50%', '90%'],
          labelLine: {
            show: false
          },
          label: {
            position: 'inner',
            fontSize: 12,
            fontWeight: 'bold',
            rotate: true,
            formatter: '{d}%'
          },
          data: [{
            value: 5,
            name: '任务车'
          }, {
            value: 12,
            name: '吊舱'
          }, {
            value: 1,
            name: 'VSAT天线'
          }, {
            value: 1,
            name: '4G基站'
          }, {
            value: 1,
            name: '铱星'
          }, {
            value: 1,
            name: '灭火包'
          }, {
            value: 1,
            name: '倾斜相机'
          }, {
            value: 1,
            name: '用户中心'
          }, {
            value: 1,
            name: '时空服务中心'
          }, {
            value: 1,
            name: '监测智慧杆'
          }, {
            value: 1,
            name: '陆地机动站'
          }]
        }]
      },
      option4: {
        tooltip: {
          confine: true,
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          top: 20,
          textStyle: {
            fontSize: 12,
            color: '#FFFFFF'
          },
          data: ['普通人', '火车', '船', '交通灯', '火焰', '烟雾']
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              type: 'solid',
              width: '2'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          type: 'category',
          data: ['2023-01-31', '2023-02-01', '2023-02-02', '2023-02-03'],
          axisPointer: {
            type: 'shadow'
          }
        },
        yAxis: [{
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          type: 'value',
          name: '',
          min: 0
        }],
        series: [{
          itemStyle: {
            color: {
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: '#FB5F85'
              }, {
                offset: 0.5,
                color: '#FB5F8550'
              }, {
                offset: 1,
                color: '#FB5F8500'
              }]
            }
          },
          name: '普通人',
          type: 'bar',
          smooth: true,
          data: [0, 1, 4, 6, 8, 5]
        }, {
          itemStyle: {
            color: {
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: '#0285F0'
              }, {
                offset: 0.5,
                color: '#0285F050'
              }, {
                offset: 1,
                color: '#0285F000'
              }]
            }
          },
          name: '火车',
          type: 'bar',
          smooth: true,
          data: [1, 5, 9, 4, 2, 1]
        }, {
          itemStyle: {
            color: {
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: '#B86AF7'
              }, {
                offset: 0.5,
                color: '#B86AF750'
              }, {
                offset: 1,
                color: '#B86AF700'
              }]
            }
          },
          name: '船',
          type: 'bar',
          smooth: true,
          data: [1, 2, 6, 1, 5, 1]
        }, {
          itemStyle: {
            color: {
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: '#1FB81B'
              }, {
                offset: 0.5,
                color: '#1FB81B50'
              }, {
                offset: 1,
                color: '#1FB81B00'
              }]
            }
          },
          name: '交通灯',
          type: 'bar',
          smooth: true,
          data: [5, 1, 3, 6, 8, 2]
        }, {
          name: '火焰',
          type: 'line',
          smooth: true,
          showSymbol: false,
          data: [0, 2, 8, 3, 5, 2]
        }, {
          name: '烟雾',
          type: 'line',
          smooth: true,
          showSymbol: false,
          data: [3, 9, 2, 8, 7, 1]
        }]
      },
      option5: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          backgroundColor: "rgba(9, 24, 48, 0.5)",
          borderColor: "rgba(75, 253, 238, 0.4)",
          textStyle: {
            color: "#CFE3FC",
            width: 120
          },
          borderWidth: 1,
          formatter: function (params) {
            let str = "";
            for (let i = 0; i < params.length; i++) {
              if (i == 0) {
                str += `${params[i].name}<br/>${params[i].seriesName.slice(0, params[i].seriesName.indexOf("("))}` + ": " + `<span>${params[0].data}</span>M<br/>`;
                continue;
              }
              str += `${params[i].seriesName.slice(0, params[i].seriesName.indexOf("("))}` + ": " + `<span>${params[i].data}</span>h`;
            }
            return str;
          }
        },
        legend: [{
          data: ["使用时长(h)"],
          left: 30,
          top: 10,
          itemWidth: 14,
          borderColor: "rgba(255, 192, 0, 1)",
          textStyle: {
            color: "#c1cadf",
            fontSize: 12
          }
        }, {
          data: ["流量(M)"],
          right: 20,
          top: 10,
          itemStyle: {
            borderWidth: 2
          },
          textStyle: {
            color: "#c1cadf",
            fontSize: 12
          }
        }],
        toolbox: {
          show: true,
          orient: "vertical",
          x: "right",
          y: "center"
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
        },
        yAxis: [{
          type: "value",
          axisTick: {
            show: true
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(120, 160, 236, 1)"
            },
            symbol: ["none", "arrow"],
            symbolSize: [5, 12],
            symbolOffset: [0, 10]
          },
          axisLabel: {
            interval: 0,
            color: "rgba(207, 227, 252, 1)"
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(39, 57, 75, 1)",
              width: 1,
              type: "solid"
            }
          }
        }, {
          type: "value",
          axisTick: {
            show: true
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(207, 227, 252, 1)t"
            },
            symbol: ["none", "arrow"],
            symbolSize: [5, 12],
            symbolOffset: [0, 10]
          },
          axisLabel: {
            interval: 0,
            color: "rgba(207, 227, 252, 1)",
            formatter: "{value}"
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(39, 57, 75, 1)",
              width: 1,
              type: "solid"
            }
          }
        }],
        series: [{
          name: "流量(M)",
          yAxisIndex: 1,
          type: "line",
          smooth: true,
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: "rgba(98, 227, 255, 1)"
            }, {
              offset: 1,
              color: "rgba(98, 227, 255, 0)"
            }])
          },
          label: {
            normal: {
              show: true,
              position: "top",
              textStyle: {
                color: "#00FFF0FF",
                fontSize: 8
              }
            }
          },
          data: [30, 150, 53, 342, 66, 71, 220, 80, 120, 90, 80, 77],
          symbol: "circle",
          symbolSize: 8,
          itemStyle: {
            normal: {
              color: "#FFFFFF",
              borderColor: "rgba(0, 255, 240, 1)",
              lineStyle: {
                color: "rgba(0, 255, 240, 1)"
              }
            }
          }
        }, {
          type: "bar",
          yAxisIndex: 0,
          name: "使用时长(h)",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(232, 98, 32, 1)"
              }, {
                offset: 1,
                color: "rgba(232, 98, 32, 0)"
              }], false)
            }
          },
          barWidth: 24,
          data: [12, 23, 21, 32, 24, 35, 33, 22, 32, 69, 56, 89]
        }]
      }
    });
    return (_ctx, _cache) => {
      const _component_el_tree_select = _resolveComponent("el-tree-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "item-text"
      }, "本年度飞行时长(h)", -1)), _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(totalFlightTimeInYear)), 1)]), _createElementVNode("div", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "item-text"
      }, "本月飞行时长(h)", -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(totalFlightTimeInMonth)), 1)]), _createElementVNode("div", _hoisted_9, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "item-text"
      }, "本年度飞行公里数(km)", -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(totalFlightDistanceInYear)), 1)]), _createElementVNode("div", _hoisted_11, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "item-text"
      }, "本月飞行公里数(km)", -1)), _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(totalFlightDistanceInMonth)), 1)])]), _createVNode(_component_el_form, {
        model: _unref(queryParams),
        ref: "queryRef",
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "机组",
          prop: "deptId"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tree_select, {
            modelValue: _unref(queryParams).deptId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(queryParams).deptId = $event),
            data: _unref(deptOptions),
            props: {
              value: 'id',
              label: 'label',
              children: 'children'
            },
            "check-strictly": "",
            clearable: "",
            placeholder: "请选择机组",
            "value-key": "id",
            style: {
              "width": "28rem"
            }
          }, null, 8, ["modelValue", "data"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "飞行设备",
          prop: "deviceId"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(queryParams).deviceId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(queryParams).deviceId = $event),
            clearable: "",
            placeholder: "飞行设备",
            style: {
              "width": "18rem"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(droneList), dict => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: dict.id,
                label: dict.name,
                value: dict.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "任务时间",
          style: {
            "width": "41rem"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(DatePicker), {
            ref: "datePickerRef",
            onSetDateRange: setDateRange,
            onSetGroupByType: setGroupByType
          }, null, 512)]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            icon: "Search",
            class: "satpro-button",
            onClick: handleQuery
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("搜索", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            icon: "Refresh",
            class: "satpro-button",
            onClick: resetQuery
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("重置", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4,
          xs: 24
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("div", {
            class: "menu-name",
            style: {
              "left": "5.4rem"
            }
          }, [_createElementVNode("span", {
            class: "textinfo"
          }, "载体任务统计")], -1), _createElementVNode("div", {
            class: "echarts0"
          }, [_createElementVNode("div", {
            id: "myChart",
            style: {
              "width": "38rem",
              "height": "28.5rem",
              "display": "inline-block"
            }
          }), _createElementVNode("div", {
            id: "myChart1",
            style: {
              "width": "38rem",
              "height": "28.5rem",
              "display": "inline-block"
            }
          }), _createElementVNode("div", {
            id: "myChart2",
            style: {
              "width": "38rem",
              "height": "28.5rem",
              "display": "inline-block"
            }
          })], -1), _createElementVNode("div", {
            class: "menu-name",
            style: {
              "left": "1.6rem"
            }
          }, [_createElementVNode("span", {
            class: "textinfo"
          }, "流量统计")], -1), _createElementVNode("div", {
            class: "echarts1"
          }, [_createElementVNode("div", {
            id: "myChart5",
            style: {
              "width": "58rem",
              "height": "28.5rem"
            }
          })], -1)]))]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 20,
          xs: 24
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createElementVNode("div", {
            class: "menu-name",
            style: {
              "left": "91.6rem"
            }
          }, [_createElementVNode("span", {
            class: "textinfo"
          }, "设备统计")], -1), _createElementVNode("div", {
            class: "echarts2"
          }, [_createElementVNode("div", {
            id: "myChart3",
            style: {
              "width": "100%",
              "height": "28.5rem"
            }
          })], -1), _createElementVNode("div", {
            class: "menu-name",
            style: {
              "left": "33.4rem"
            }
          }, [_createElementVNode("span", {
            class: "textinfo"
          }, "告警种类数据统计")], -1), _createElementVNode("div", {
            class: "echarts3"
          }, [_createElementVNode("div", {
            id: "myChart4",
            style: {
              "width": "100%",
              "height": "28.5rem"
            }
          })], -1)]))]),
          _: 1
        })]),
        _: 1
      })])])])]);
    };
  }
};